module.exports = __webpack_public_path__ + "img/youtube.e722de10.svg";